const IconFacebookViolet = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_847_2758)">
                <path d="M5.8335 12.7795V13.2795H6.3335H7.66683V18.3933C4.01718 17.3695 1.3335 14.0126 1.3335 10.0226C1.3335 5.22493 5.21748 1.33301 10.0002 1.33301C14.7828 1.33301 18.6668 5.22493 18.6668 10.0226C18.6668 14.3428 15.5258 17.9203 11.4168 18.5964V13.2795H13.6668H14.1668V12.7795V10.0226V9.52265H13.6668H11.4168V8.18472C11.4168 7.95425 11.6067 7.76576 11.8335 7.76576H13.6668H14.1668V7.26576V4.50886V4.00886H13.6668H11.3752C9.32867 4.00886 7.66683 5.67668 7.66683 7.72524V9.52265H6.3335H5.8335V10.0226V12.7795Z" fill="#494E7B" stroke="#494E7B" />
            </g>
            <defs>
                <clipPath id="clip0_847_2758">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconFacebookViolet